const DelegatingMdcBlockGroup = require('../_DelegatingMdcBlockGroup');

const types = require('./types');

class MenuSelection extends DelegatingMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = types;
    }
}

module.exports = MenuSelection;
